var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"description-disclaimer"},[_vm._v(" Search our database of family records from China and abroad and decode the stories of your ancestors with our handy Chinese-English dictionary! ")])}
var staticRenderFns = []

export { render, staticRenderFns }